import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminMenuItemService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiURL}/admin/menu-items`;

  getItems(filters?: {
    page?: number;
    size?: number;
    restaurantId?: number;
    categoryId?: number;
    available?: boolean;
    search?: string;
  }): Observable<any> {
    let params = new HttpParams();

    if (filters) {
      if (filters.page !== undefined) params = params.set('page', filters.page.toString());
      if (filters.size) params = params.set('size', filters.size.toString());
      if (filters.restaurantId) params = params.set('restaurantId', filters.restaurantId.toString());
      if (filters.categoryId) params = params.set('categoryId', filters.categoryId.toString());
      if (filters.available !== undefined) params = params.set('available', filters.available.toString());
      if (filters.search) params = params.set('search', filters.search);
    }

    return this.http.get(this.apiUrl, {params});
  }

  getItemById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  getItemsByRestaurant(restaurantId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/restaurant/${restaurantId}`);
  }

  getItemsByCategory(categoryId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/category/${categoryId}`);
  }

  createItem(item: any): Observable<any> {
    return this.http.post(this.apiUrl, item);
  }

  updateItem(id: number, item: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, item);
  }

  deleteItem(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  updateAvailability(id: number, available: boolean): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${id}/availability`, {available});
  }

  updateStock(id: number, outOfStock: boolean): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${id}/stock`, {outOfStock});
  }

  uploadImage(id: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('image', file);
    return this.http.post(`${this.apiUrl}/${id}/image`, formData);
  }

  bulkUpdateAvailability(ids: number[], available: boolean): Observable<any> {
    return this.http.patch(`${this.apiUrl}/bulk/availability`, {ids, available});
  }

  bulkDelete(ids: number[]): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/bulk/delete`, {ids});
  }

  getRestaurants(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiURL}/admin/restaurants/list`);
  }

  getCategories(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiURL}/admin/categories/list`);
  }

  duplicateItem(id: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/${id}/duplicate`, {});
  }
}

